/**
 * @file
 * script.js
 *
 * Custom Javascript
 */
+function ($) {
  'use strict';
  $(window).on('load', function (e) {
    var tHeight = $('.text-container').height();
    var iHeight = $('.image-container').height();
    if (tHeight > iHeight) {
      $('.image-container').height(tHeight);
    } else {
      $('.text-container').height(iHeight - 100);
    }

    // Navbar change scroll size
    var scrollTop = 0;
    $(window).scroll(function(){
      scrollTop = $(window).scrollTop();

      if (scrollTop >= 100) {
        $('#top').addClass('scrolled-nav');
      } else if (scrollTop < 100) {
        $('#top').removeClass('scrolled-nav');
      }
    });

    $('#simple-menu').sidr({
      name: 'slide-menu',
      side: 'right',
      displace: false
    });
  });
}(jQuery);
